import { useEffect, useState } from 'react';
import { SharedValue, useSharedValue, withSpring, useDerivedValue, runOnJS } from 'react-native-reanimated';
import { ACTIVE_THUMBNAIL_MARGIN, ACTIVE_THUMBNAIL_WIDTH, THUMBNAIL_MARGIN, THUMBNAIL_WIDTH } from '@v2/components/imageHandling/constants';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { fullWidth } from '@components/frame';

interface Params {
  imagesLength: number;
  selectedIndex: number;
  scrollProgress?: SharedValue<number>;
  width?: number;
  scale: ScaleFunction;
}

export const useSmallSliderCalculations = ({ imagesLength, selectedIndex, scrollProgress, width = fullWidth, scale }: Params) => {
  const animatedTranslateX = useSharedValue(0);

  const [isFirstAnimationComplete, setIsFirstAnimationComplete] = useState(false);

  const ITEM_WIDTH = scale(THUMBNAIL_WIDTH + THUMBNAIL_MARGIN * 2, false);
  const ACTIVE_ITEM_WIDTH = scale(ACTIVE_THUMBNAIL_WIDTH + ACTIVE_THUMBNAIL_MARGIN * 2, false);

  const posIndex = imagesLength - 1 - selectedIndex;
  const centerOffset = (imagesLength - 1) / 2;

  useEffect(() => {
    if (!scrollProgress) {
      animatedTranslateX.value = withSpring((centerOffset - posIndex) * ITEM_WIDTH, {
        damping: 15,
        stiffness: 150,
      });
    }
  }, [selectedIndex, posIndex, centerOffset, ITEM_WIDTH, scrollProgress]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFirstAnimationComplete(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useDerivedValue(() => {
    if (scrollProgress) {
      const baseOffset = -width / 2 + ACTIVE_ITEM_WIDTH / 2;
      animatedTranslateX.value = baseOffset + scrollProgress.value * ITEM_WIDTH;
    }
  });

  return {
    ITEM_WIDTH,
    ACTIVE_ITEM_WIDTH,
    animatedTranslateX,
    isFirstAnimationComplete,
  };
};
